import type { ReactElement } from 'react';

import { Flex, Skeleton } from '@rango-dev/whale';
import React from 'react';

import styles from './BlockchainSkeleton.module.css';

const NUMBER_OF_TOKEN_SKELETON = 3;
const TOKEN_SKELETON_KEYS = Array.from(
  { length: NUMBER_OF_TOKEN_SKELETON },
  (_, index) => `token-skeleton-${index}`,
);

export function BlockchainSkeleton(): ReactElement {
  return (
    <>
      {TOKEN_SKELETON_KEYS.map((key) => (
        <Flex key={key} align="center" justify="between" gap="2">
          <Flex align="center" gap="2">
            <Skeleton width="32px" height="32px" className={styles.circle} />
            <Flex direction="column" gap="1">
              <Skeleton width="87px" height="16px" />
              <Skeleton width="58px" height="12px" />
            </Flex>
          </Flex>
          <Flex direction="column" gap="1">
            <Skeleton width="54px" height="16px" />
            <Skeleton width="39px" height="12px" />
          </Flex>
          <Skeleton width="24px" height="24px" className={styles.circle} />
        </Flex>
      ))}
    </>
  );
}
